import {
  format, startOfWeek, startOfMonth, endOfMonth,
  startOfQuarter, startOfYear, subDays, subMonths
} from 'date-fns';

export const localDateBoundaryIso = (value, endOfDay = false) => (
  new Date(`${value}T${endOfDay ? '23:59:59.999' : '00:00:00.000'}`).toISOString()
);

export const getSalesRangeDates = (rangeKey, today = new Date()) => {
  let from = '', to = format(today, 'yyyy-MM-dd');
  if (rangeKey === 'today') from = to;
  else if (rangeKey === 'yesterday') { from = format(subDays(today, 1), 'yyyy-MM-dd'); to = from; }
  else if (rangeKey === 'week') from = format(startOfWeek(today, { weekStartsOn: 1 }), 'yyyy-MM-dd');
  else if (rangeKey === 'month') from = format(startOfMonth(today), 'yyyy-MM-dd');
  else if (rangeKey === 'previous_month') {
    const previousMonth = subMonths(today, 1);
    from = format(startOfMonth(previousMonth), 'yyyy-MM-dd');
    to = format(endOfMonth(previousMonth), 'yyyy-MM-dd');
  } else if (rangeKey === 'quarter') from = format(startOfQuarter(today), 'yyyy-MM-dd');
  else if (rangeKey === 'year') from = format(startOfYear(today), 'yyyy-MM-dd');
  return { from, to };
};

export const getTargetMonthRange = (today = new Date()) => ({
  start: format(startOfMonth(today), 'yyyy-MM-dd'),
  end: format(endOfMonth(today), 'yyyy-MM-dd')
});
